const Terser = require("terser");
window.Terser = Terser;
